module.exports = __webpack_public_path__ + "static/media/login5_catwalk.d779eaf9.svg";